var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"solarCalcApp"}},[_c('container',{staticClass:"my-auto"},[(this.$storage.state.passed.length <= this.$storage.state.steps.length-2)?_c('heading'):_vm._e(),_c('steps'),(_vm.$storage.state.loading)?_c('loading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }